module.exports = __webpack_public_path__ + "static/media/unsecured-loan-funds.9c59805c.svg";